import { css, Theme } from "@emotion/react";

import { HorizontalAlign } from "../../../Layout/SimpleTable/HorizontalAlign";
import { VerticalAlign } from "../../../Layout/SimpleTable/VerticalAlign";

export const emptyBodyCell = css({});

export const bodyCell =
    (
        align: undefined | HorizontalAlign,
        valign: undefined | VerticalAlign,
        empty: boolean,
        gray: boolean,
        indent: number | undefined,
        textTopPadding: boolean,
        paddingTop: undefined | number | string
    ) =>
    (theme: Theme) =>
        css(
            {
                padding: "20px 5px 0",
                fontSize: theme.candy.typography.primary.fontSize.css(),
                lineHeight: "22px",
                whiteSpace: "normal",
            },
            align && { textAlign: align },
            valign && { verticalAlign: valign },
            empty && {
                color: theme.candy.typography.inactive.color,
                textAlign: "center",
                lineHeight: "30px",
            },
            gray && {
                color: theme.candy.typography.secondary.color,
                textAlign: "center",
            },
            indent && { paddingLeft: indent != undefined ? 12 + indent * 12 : undefined },
            paddingTop != undefined && { paddingTop: paddingTop },
            textTopPadding && { paddingTop: 20 + 7 }
        );

export const baseLineHackText = css({
    lineHeight: "34px",
});

export const baseLineHackChildren = css({
    display: "inline-flex",
});
